import { FC } from "react";

import { RelatedCasesTable } from "src/components/case/RelatedCasesTable";
import { PassiveModal } from "src/components/Modal";
import { useGetRuleExecutionResultByIdQuery } from "src/graphql/anti-fraud/queries/rules/RuleExecutionResultQuery.ts";
import { useT } from "src/internationalization";

export type AssociatedCasesModalProps = {
  onClose: () => void;
  ruleExecutionId: string;
};

export const AssociatedCasesModal: FC<AssociatedCasesModalProps> = ({
  onClose,
  ruleExecutionId,
}) => {
  const t = useT();

  const {
    data: cases,
    loading,
    error,
  } = useGetRuleExecutionResultByIdQuery({ id: ruleExecutionId });

  return (
    <PassiveModal
      onClose={onClose}
      size="xl"
      title={t("cases.relatedCases.modal.title", {
        number: cases.length ?? "",
      })}
      fullHeight
    >
      <div className="h-full">
        <RelatedCasesTable cases={cases} loading={loading} isError={!!error} />
      </div>
    </PassiveModal>
  );
};
